import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class CompanyColorType {
    _id?: string;
	id?: string;
	name?: string;
	color?: string;
CompanyId?: string;
	
}


@Injectable()
export class CompanyColorService {
	static parameters = [HttpClient];
    constructor(private http: HttpClient) {
        this.http = http;
    }

	query(query:{}): Observable<CompanyColorType[]> {
	  if( query != undefined ){
			 var body = {};
			 body["where"] = JSON.stringify(query);
			 return this.http.get('/api/companycolors', {params: body}) as Observable<CompanyColorType[]>;
        }else{
            return this.http.get('/api/companycolors') as Observable<CompanyColorType[]>;
        }
       
    }
	queryInclude(query:{}, include:{}): Observable<CompanyColorType[]> {
	  if( query != undefined || include != undefined ){
			    var body = {};
			 body["where"] = JSON.stringify(query);
			 body["include"] = JSON.stringify(include);
			 return this.http.get('/api/companycolors',  {params: body}) as Observable<CompanyColorType[]>;
        }else{
            return this.http.get('/api/companycolors') as Observable<CompanyColorType[]>;
        }
       
    }
    get(id: string): Observable<CompanyColorType> {
        return this.http.get(`/api/companycolors/${id}`) as Observable<CompanyColorType>;
    }
    create(companycolor: CompanyColorType): Observable<CompanyColorType> {
        return this.http.post(`/api/companycolors`, companycolor);
    }
	update(companycolor: CompanyColorType): Observable<CompanyColorType> {
       return this.http.put(`/api/companycolors/${companycolor.id || companycolor._id}`, companycolor);
    }
    updateInclude(companycolor: CompanyColorType, query:{}, include:{}): Observable<CompanyColorType[]> {
      if( query != undefined || include != undefined ){
			    var body = {};
			 body["where"] = JSON.stringify(query);
			 body["include"] = JSON.stringify(include);
			 return this.http.put(`/api/companycolors/${companycolor.id || companycolor._id}`,  companycolor,  {params: body}) as Observable<CompanyColorType[]>;
        }else{
            return this.http.put(`/api/companycolors/${companycolor.id || companycolor._id}`, companycolor) as Observable<CompanyColorType[]>;
        }
    }
	remove(companycolor): Observable<CompanyColorType> {
        return this.http.delete(`/api/companycolors/${companycolor.id || companycolor._id}`);
    }
    queryRemove(query:{}): Observable<CompanyColorType> {
		var body = {};
		body["where"] = JSON.stringify(query);
        return this.http.delete('/api/companycolors',  {params: body});
    }
        getByUrl(url): Observable<any> {
			return this.http.get(url);
		}
}

